import { gql } from '@apollo/client'

export const GET_ROLES = gql`
  query MyQuery {
    getRoles {
      id
      name
      default
      can_assign_external
    }
  }
`
